import Connect from './Connect'

export default {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/project/:projectId/connect',
      component: Connect,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/project/connect/connectConfig.js